import dayjs from 'dayjs';

const minTimestamp = new Date('2020').getTime();
export const timeFmt = (timestamp: number | string) => {
  if (typeof timestamp === 'number' && timestamp < minTimestamp) timestamp *= 1000;
  return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
};
